import { render } from "./InteractionsPage.vue?vue&type=template&id=43eaa0a6&ts=true"
import script from "./InteractionsPage.vue?vue&type=script&lang=ts"
export * from "./InteractionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__